
function Footer() {
  return (
    <div className="w-full bg-white bottom-0 z-[100]">
      <div className="w-full px-[8vw] bg-white py-[4vh] font-semibold text-[1rem] lg:text-[1.3rem] text-center text-Typo">
        <p>
          © Copyright 2023 Article Harbor - All rights reserved. Powered By :
          ESI
        </p>
      </div>
    </div>
  );
}

export default Footer;
